import { Component, type ErrorInfo, type ReactNode } from 'react';

/** 화면 렌더링 중 예외가 나도 빈 화면 대신 복구 버튼을 보여준다. 오류 내용은 사용자에게 보이지 않는다(개인정보 포함 가능). */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) {
    // 운영에서는 오류 수집 서비스로 보낸다(개인정보가 섞이지 않도록 메시지·스택만)
    console.error('render error', error.message, info.componentStack);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="center-screen">
        <div className="card stack" role="alert">
          <h1>화면을 그리지 못했습니다</h1>
          <p className="muted">일시적인 문제일 수 있습니다. 다시 시도해도 반복되면 로그아웃 후 다시 로그인해 주세요.</p>
          <div className="btn-row">
            <button type="button" className="btn btn-primary" onClick={() => this.setState({ failed: false })}>다시 시도</button>
            <button type="button" className="btn btn-ghost" onClick={() => window.location.reload()}>새로고침</button>
          </div>
        </div>
      </div>
    );
  }
}
